import React, {useState, useEffect, useContext} from 'react'

import {DataContext} from '../../dataContext'
import MajorityMeter from '../../utilities/MajorityMeter';
import Declaration from '../../utilities/Declaration';
import LiveUpdates from '../../utilities/LiveUpdates';
import YearButtons from '../../utilities/YearButtons';
import Party from '../../utilities/Party';

export default function App() {
    const {data} = useContext(DataContext)
	const [parties, setParties] = useState([])

	const {results} = data

    useEffect(()=> {
		// console.log(results.party === true)
        if (results.party) {
			setParties([])
            results.party.partyResults.map((party, i)=>{
				setParties(oldArray=>[...oldArray, {partyName: party.nameShort,id:i, seats: party.seats, color: party.color,votesPercent: party.votesPercent,votesTotal: party.votes}])
				return;
			})
		}

    }, [results])

    return (
        <div className={'classes.barchartApp h-full max-h-[300px] relative'}>
            {(data.config && results.party) && 
             <div className={'classes.main flex flex-col h-full'} tabIndex="0" aria-labelledby='widgetTitle'>
                <div className={'classes.titleRow flex justify-between'}>
					<div className={'classes.left'}>
						<h2 id="widgetTitle" className={'classes.title text-lg xs:text-2xl font-bold'}>{data.config.title}</h2>
						

					</div>
					{(data.config.prevyear) 
					 && 
						<YearButtons />
					}
				</div>
				{results.declaration && <Declaration declaration={results.declaration} showLeading={true} majority={data.config.majority}/>}
                <div className={'classes.barchart pt-8 flex-grow'} tabIndex="0" aria-label={`${data.config.majority} seats needed for majority win`}>
                    <MajorityMeter limit={false} longText={false} seatTotal={data.config.seats} majority={data.config.majority} majorityPercent={(data.config.majority/data.config.seats)*100} data={results.party}/>
                </div>
                
                <div className={'flex justify-around gap-2'}>
                    {parties.sort((a,b)=>{
						if (a.seats > b.seats) {
							return -1
						} else if (a.seats < b.seats) {
							return 1
						} else return 0
					}).map(party=>{
						return <Party key={party.id} party={party}/>
					})}
                </div> 
				{data.config.election_day &&
					<LiveUpdates time={results.party.generated} />
				}
            </div>
            }
        </div>
    )
}
